export default __webpack_public_path__ + "static/notebook-6112eb3105f13448966d1d07160a8c30.jpg";